import { Outlet, useLocation, Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AnnouncementBar } from "@/components/AnnouncementBar";
import { CookieBanner } from "@/components/CookieBanner";
import { SeoManager } from "@/components/SeoManager";
import { BrandLogo } from "@/components/BrandLogo";
import { useSite } from "@/context/SiteContext";
import { useAuth } from "@/context/AuthContext";

const Maintenance = ({ message }) => {
  const { t } = useSite();
  return (
    <div className="min-h-screen bg-[#fbf9f7] flex flex-col items-center justify-center text-center px-6" data-testid="maintenance-page">
      <BrandLogo className="h-16" testId="maintenance-logo-link" />
      <h1 className="font-display text-4xl sm:text-5xl font-black text-neutral-900 mt-10">{t("We'll be right back.")}</h1>
      <p className="text-neutral-600 mt-4 max-w-md">{t(message)}</p>
      <Link to="/login" className="mt-8 text-sm text-neutral-400 underline hover:text-[#d00000]" data-testid="maintenance-login-link">{t("Team login")}</Link>
    </div>
  );
};

const Hidden = () => {
  const { t } = useSite();
  return (
    <div className="max-w-3xl mx-auto px-5 py-32 text-center" data-testid="page-unavailable">
      <h1 className="font-display text-4xl font-black text-neutral-900">{t("This page isn't available right now.")}</h1>
      <Link to="/" className="inline-block mt-6 text-[#d00000] underline">{t("Back to home")}</Link>
    </div>
  );
};

export const Layout = () => {
  const { config } = useSite();
  const { user } = useAuth();
  const { pathname } = useLocation();
  const vis = config?.visibility || {};
  if (vis.maintenance_mode && !user?.is_admin) return <Maintenance message={vis.maintenance_message} />;
  const hidden = (vis.hidden_pages || []).includes(pathname) && !user?.is_admin;
  return (
    <div className="min-h-screen bg-[#fbf9f7]">
      <SeoManager />
      <div className="sticky top-0 z-50">
        {vis.show_announcements !== false && <AnnouncementBar />}
        <Navbar />
      </div>
      <main>{hidden ? <Hidden /> : <Outlet />}</main>
      <Footer />
      <CookieBanner />
    </div>
  );
};
